import {useParams} from '@github-ui/react-router'

/**
 * Parses the thread ID from the current URL and returns it.
 * We have to rely on the URL from the browser history because the thread ID in the React Router state may be stale
 * since we manually push a history entry when creating a new thread and don't perform a navigation.
 */
export function useRouteThreadId() {
  const {threadID} = useParams<{threadID: string}>()

  return threadID ?? null
}
